import React, { useState } from 'react';
import _ from 'lodash';
import {
  Checkbox,
  List,
  ListItem,
  Popover,
  Radio,
  TextField,
  Typography,
} from '@material-ui/core';
import { SearchIcon } from '../../assets/icons';
import { PopoverSearchableListProps } from './types';
import useStyles from './styles';

const PopoverSearchableList = (
  props: PopoverSearchableListProps,
) => {
  const classes = useStyles();
  const {
    single,
    data,
    options,
    onClickOption,
    children,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState('');

  const debounceCallBack = _.debounce((e, callBack) => {
    callBack();
  }, 200);

  const handleSearch = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    e.persist();
    debounceCallBack(e, () => {
      setSearch(e.target.value);
    });
  };

  const handleOpen = (e: any) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e: any) => {
    e.stopPropagation();
    setSearch('');
    setAnchorEl(null);
  };

  const handleSelect = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    value: string,
  ) => {
    let newValues:any = data || (single ? '' : []);
    if (single) {
      if (newValues !== value) {
        newValues = value;
      }
    } else if (_.isArray(newValues)) {
      const index = newValues.indexOf(value);
      const isChecked = index > -1;
      if (!isChecked) {
        newValues.push(value);
      } else {
        newValues.splice(index, 1);
      }
    }
    onClickOption(e, newValues);
  };

  const renderListItem = (
    option: {
      value: string,
      label: string,
      disabled?: boolean,
    },
  ) => {
    if (single) {
      return (
        <ListItem
          button
          disabled={option?.disabled}
          key={option.value}
          className={classes.listItem}
          onClick={(e) => handleSelect(e, option.value)}
        >
          <Radio
            checked={data === option.value}
          />
          <Typography className={classes.label}>
            { option.label }
          </Typography>
        </ListItem>
      );
    }

    let isChecked = false;

    if (data && option.value) {
      const index = data.indexOf(option.value);
      isChecked = index > -1;
    }
    return (
      <ListItem
        button
        disabled={option.disabled}
        key={option.value}
        className={classes.listItem}
        onClick={(e) => handleSelect(e, option.value)}
      >
        <Checkbox
          checked={isChecked}
        />
        <Typography className={classes.label}>
          { option.label }
        </Typography>
      </ListItem>
    );
  };

  const renderList = () => {
    let newOptions = options || [];
    if (search) {
      newOptions = newOptions.filter((option) => (
        option.label.toLowerCase().includes(search.trim().toLowerCase())
      ));
    }
    return (
      <List
        disablePadding
        className={classes.list}
      >
        {
          newOptions.length > 0
            ? newOptions.map((option) => renderListItem(option))
            : (
              <ListItem disabled>
                <Typography>
                  No result found
                </Typography>
              </ListItem>
            )
        }
      </List>
    );
  };

  return (
    <>
      {typeof children === 'function' ? children({ isOpen: Boolean(anchorEl), open: handleOpen, close: handleClose }) : children}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className={classes.root}>
          <TextField
            fullWidth
            placeholder="Search"
            variant="outlined"
            InputProps={{
              endAdornment: <img alt="search" className={classes.icon} src={SearchIcon} />,
            }}
            onChange={handleSearch}
            size="small"
            value={undefined}
          />
          { renderList() }
        </div>
      </Popover>
    </>
  );
};

export default PopoverSearchableList;
